/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Package, Package$inboundSchema } from "./package.js";

export type ListPackagesResult = {
  /**
   * The list of packages
   */
  packages: Array<Package>;
};

/** @internal */
export const ListPackagesResult$inboundSchema: z.ZodMiniType<
  ListPackagesResult,
  unknown
> = z.object({
  packages: z.array(Package$inboundSchema),
});

export function listPackagesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListPackagesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListPackagesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListPackagesResult' from JSON`,
  );
}
